import { Component, Input, ViewChildren, QueryList, ElementRef } from '@angular/core';

import { CidadeSubRegiaoBairro } from './cidade-sub-regiao-bairro';

import { ApiError, BaseFormList, MessageService } from '../../../core';

import { Cidade } from '../../cidade';
import { cidadeClassificacoes } from '../classificacao-abc';

@Component({
    selector: 'sgt-cidade-sub-regiao-bairro',
    templateUrl: './cidade-sub-regiao-bairro.component.html',
    styleUrls: ['./cidade-sub-regiao-bairro.component.less']
})
export class CidadeSubRegiaoBairroComponent implements BaseFormList<CidadeSubRegiaoBairro> {
    @Input() entities: CidadeSubRegiaoBairro[];
    classificacoes = cidadeClassificacoes;

    @ViewChildren('inputBairroNome') inputsBairroNome: QueryList<ElementRef>;

    constructor(private messageService: MessageService) { }

    insert() {
        const entity = new CidadeSubRegiaoBairro();
        this.entities.push(entity);

        setTimeout(() => this.setFocusInputNome(), 200);
    }

    /** Seta o foco no input do nome ao inserir uma nova sub-região do bairro */
    private setFocusInputNome() {
        if (!this.inputsBairroNome) {
            return;
        }
        // Obtendo o último typeahead para setar o foco
        const input = this.inputsBairroNome.last;
        if (input) {
            jQuery(input.nativeElement).focus();
        }
    }

    delete(index: number) {
        this.messageService.confirm('Deseja realmente excluir esse bairro?').then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Resolve os bairros presentes na sub-região */
    resolve() {
        if (!this.entities) {
            return;
        }

        // Removendo os bairros sem nome
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (!entity.nome || entity.nome.trim().length === 0) {
                this.entities.splice(i, 1);
            }
        }
    }
}
